import "./ListSearch.scss";
import { ComponentWrapper } from "/App.Components";
import { ComponentWrapperProps } from "/Models/Generated/ComponentWrapperProps";

export interface Props {
  items?: ComponentWrapperProps[];
}

const ListSearch = ({ items }: Props) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <ul className="list-search-norad">
      {items.map((item, itemIdx) => (
        <li key={itemIdx}>
          <ComponentWrapper {...item} />
        </li>
      ))}
    </ul>
  );
};

export default ListSearch;
